import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Bookmark } from 'lucide-react';
import { supabase } from '../lib/supabase';
import { getWatchlist } from '../utils/watchlist';
import { usePageSeo } from '../hooks/usePageSeo';
import { absoluteUrl } from '../utils/seo';
import type { ForumBase } from '../types/forum';
interface Props {
  darkMode: boolean;
}

const WatchlistPage: React.FC<Props> = ({ darkMode }) => {
  const [forums, setForums] = useState<ForumBase[]>([]);
  const [loading, setLoading] = useState(true);

  usePageSeo({
    title: 'Takip listem',
    description: 'Takip ettiğiniz forumların güncel istatistikleri.',
    keywords: 'forum takip, izleme listesi',
    canonical: absoluteUrl('/watchlist'),
    noindex: true,
  });

  useEffect(() => {
    const load = async () => {
      const ids = getWatchlist();
      if (ids.length === 0) {
        setForums([]);
        setLoading(false);
        return;
      }
      const { data } = await supabase.from('forums').select('*').in('id', ids).eq('is_active', true);
      setForums(data || []);
      setLoading(false);
    };
    load();
    window.addEventListener('watchlist-changed', load);
    return () => window.removeEventListener('watchlist-changed', load);
  }, []);

  return (
    <div className={`min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-50'}`}>
      <div className="container mx-auto px-4 py-8">
        <Link
          to="/"
          className={`inline-flex items-center gap-2 mb-4 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}
        >
          <ArrowLeft size={20} /> Geri
        </Link>
        <h1 className="text-2xl font-bold mb-6 flex items-center gap-2">
          <Bookmark className="text-indigo-500" /> Takip listem
        </h1>
        {loading ? (
          <div className="animate-spin h-10 w-10 border-b-2 border-indigo-500 rounded-full" />
        ) : forums.length === 0 ? (
          <p className={darkMode ? 'text-gray-400' : 'text-gray-600'}>
            Henüz forum eklemediniz. Forum detay sayfasında &quot;Takip et&quot; ile ekleyebilirsiniz.
          </p>
        ) : (
          <ul className="grid gap-4">
            {forums.map((f) => (
              <li key={f.id}>
                <Link
                  to={`/forum/${f.forum_id}`}
                  className={`block p-4 rounded-xl ${darkMode ? 'bg-gray-800 hover:bg-gray-700' : 'bg-white shadow hover:shadow-md'}`}
                >
                  <span className="font-semibold">{f.name}</span>
                  <span className={`block text-sm mt-1 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                    {f.members_count.toLocaleString('tr-TR')} üye · {f.topics_count.toLocaleString('tr-TR')}{' '}
                    konu
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default WatchlistPage;
